import { InfaceEnv } from '@inface-sdk/common';
var decrypt = InfaceEnv.decrypt;
export var INPAY_ENV = {
  WEB_ALLTEM_X_INFACE_API_KEY: {
    PRE: decrypt('Y2NiM2E0ZTUtMDUzYS01MzMwLTkyMmEtOTUzNDFlNjlmNjA0'),
    // ccb3a4e5-053a-5330-922a-95341e69f604
    LIVE: decrypt('Y2NiM2E0ZTUtMDUzYS01MzMwLTkyMmEtOTUzNDFlNjlmNjA0') // ccb3a4e5-053a-5330-922a-95341e69f604
  },
  ALLTEM_SERVER_ADDRESS: {
    LOCAL: decrypt('aHR0cHM6Ly9zYW5kYm94LmFwaS5uZXhvbi5jb20vYWxsdGVt'),
    // https://sandbox.api.nexon.com/alltem
    DEV: decrypt('aHR0cHM6Ly9zYW5kYm94LmFwaS5uZXhvbi5jb20vYWxsdGVt'),
    // https://sandbox.api.nexon.com/alltem
    TEST: decrypt('aHR0cHM6Ly9zYW5kYm94LmFwaS5uZXhvbi5jb20vYWxsdGVt'),
    // https://sandbox.api.nexon.com/alltem
    PRE: decrypt('aHR0cHM6Ly9wdWJsaWMuYXBpLm5leG9uLmNvbS9hbGx0ZW0='),
    // https://public.api.nexon.com/alltem
    LIVE: decrypt('aHR0cHM6Ly9wdWJsaWMuYXBpLm5leG9uLmNvbS9hbGx0ZW0=') // https://public.api.nexon.com/alltem
  },
  STAMP_SERVER_ADDRESS: {
    LOCAL: decrypt('aHR0cHM6Ly9zYW5kYm94LmFwaS5uZXhvbi5jb20vc3RhbXAvYWxwaGEvcHVibGlj'),
    // https://sandbox.api.nexon.com/stamp/alpha/public
    DEV: decrypt('aHR0cHM6Ly9zYW5kYm94LmFwaS5uZXhvbi5jb20vc3RhbXAvYWxwaGEvcHVibGlj'),
    // https://sandbox.api.nexon.com/stamp/alpha/public
    TEST: decrypt('aHR0cHM6Ly9zYW5kYm94LmFwaS5uZXhvbi5jb20vc3RhbXAvcWEvcHVibGlj'),
    // https://sandbox.api.nexon.com/stamp/qa/public
    PRE: decrypt('aHR0cHM6Ly9wdWJsaWMuYXBpLm5leG9uLmNvbS9zdGFtcC9wcmU='),
    // https://public.api.nexon.com/stamp/pre
    LIVE: decrypt('aHR0cHM6Ly9wdWJsaWMuYXBpLm5leG9uLmNvbS9zdGFtcC9saXZl') // https://public.api.nexon.com/stamp/live
  },
  DIRECT_PAYMENT_API_ADDRESS: {
    LOCAL: decrypt('aHR0cHM6Ly9kaXBheS10ZXN0Lm5leG9uLmNvbS9NYWlu'),
    // https://dipay-test.nexon.com/Main
    DEV: decrypt('aHR0cHM6Ly9kaXBheS10ZXN0Lm5leG9uLmNvbS9NYWlu'),
    // https://dipay-test.nexon.com/Main
    TEST: decrypt('aHR0cHM6Ly9kaXBheS10ZXN0Lm5leG9uLmNvbS9NYWlu'),
    // https://dipay-test.nexon.com/Main
    PRE: decrypt('aHR0cHM6Ly9kaXBheS10ZXN0Lm5leG9uLmNvbS9NYWlu'),
    // https://dipay-test.nexon.com/Main
    LIVE: decrypt('aHR0cHM6Ly9kaXBheS5uZXhvbi5jb20vTWFpbg==') // https://dipay.nexon.com/Main
  },
  JPPC_PURCHASE_HISTORY_ADDRESS: {
    LOCAL: decrypt('aHR0cHM6Ly90ZXN0LWpwLm5leG9uLmNvbS9kaXBheS9wYXltZW50L3VzYWdlLWxvZy9zaG9w'),
    // https://test-jp.nexon.com/dipay/payment/usage-log/shop
    DEV: decrypt('aHR0cHM6Ly90ZXN0LWpwLm5leG9uLmNvbS9kaXBheS9wYXltZW50L3VzYWdlLWxvZy9zaG9w'),
    // https://test-jp.nexon.com/dipay/payment/usage-log/shop
    TEST: decrypt('aHR0cHM6Ly90ZXN0LWpwLm5leG9uLmNvbS9kaXBheS9wYXltZW50L3VzYWdlLWxvZy9zaG9w'),
    // https://test-jp.nexon.com/dipay/payment/usage-log/shop
    PRE: decrypt('aHR0cHM6Ly9zdGctanAubmV4b24uY29tL2RpcGF5L3BheW1lbnQvdXNhZ2UtbG9nL3Nob3A='),
    // https://stg-jp.nexon.com/dipay/payment/usage-log/shop
    LIVE: decrypt('aHR0cHM6Ly9qcC5uZXhvbi5jb20vZGlwYXkvcGF5bWVudC91c2FnZS1sb2cvc2hvcA==') // https://jp.nexon.com/dipay/payment/usage-log/shop
  }
};